import { cn } from "@/lib/helpers/cn";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { Heading2 } from "@/ui2/atoms/Heading";
import type { Note } from "@/core/types";
import { testLocator } from "@/lib/helpers/test-locator";

import { getSubTitle } from "../helpers/get-note-subtitle";
import { getTitle } from "../helpers/get-note-title";

type NoteTitleProps = {
  className?: string;
  note: Note;
};

export function NoteTitleBlock({ className, note }: NoteTitleProps) {
  const title = getTitle(note);
  const subTitle = getSubTitle(note);

  return (
    <div className={cn("tw:flex tw:flex-col", className)}>
      <Heading2
        as="h2"
        size={1}
        {...getAutomationDataAttr("MemberProfileExportableNoteTitle")}
        {...testLocator("noteTitle")}
      >
        {title}
      </Heading2>

      {subTitle && <span className="body-md">{subTitle}</span>}
      {note.cpt_code && (
        <span className="body-sm" {...testLocator("noteCptCode")}>
          {note.cpt_code}
        </span>
      )}
    </div>
  );
}
